export default "__VITE_ASSET__8I6B8Mdr__"